import { render } from "./PagesModal.vue?vue&type=template&id=6f2abd6f&scoped=true"
import script from "./PagesModal.vue?vue&type=script&lang=js"
export * from "./PagesModal.vue?vue&type=script&lang=js"

import "./PagesModal.vue?vue&type=style&index=0&id=6f2abd6f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f2abd6f"]])

export default __exports__